import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/test',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/auth(.html)?',
      name: 'auth',
      component: () => import(/* webpackChunkName: "auth" */ './views/login/mobile/Auth.vue'),
    },
    {
      path: '/blank(.html)?',
      name: 'blank',
      component: () => import(/* webpackChunkName: "auth" */ './views/login/mobile/blank.vue'),
    },
    {
      path: '/wechat-login(.html)?',
      name: 'wechatLogin',
      component: () => import(/* webpackChunkName: "wechatLogin" */ './views/login/mobile/wechat/wechat.vue'),
    },
    {
      path: '/pptv-login(.html)?',
      name: 'pptvLogin',
      component: () => import(/* webpackChunkName: "pptvLogin" */ './views/login/mobile/pptv/pptv.vue'),
    },
    {
      path: '/login(.html)?',
      name: 'phoneLogin',
      component: () => import(/* webpackChunkName: "phoneLogin" */ './views/login/mobile/phone/phone.vue'),
    },
    {
      path: '/ologin(.html)?',
      name: 'otherLogin',
      component: () => import(/* webpackChunkName: "otherLogin" */ './views/login/mobile/phone/other.vue'),
    },
    {
      path: '/slogin(.html)?',
      name: 'sportLogin',
      component: () => import(/* webpackChunkName: "sportLogin" */ './views/login/mobile/phone/sport.vue'),
    },
    {
      path: '/sn-login(.html)?',
      name: 'snLogin',
      component: () => import(/* webpackChunkName: "phoneLogin" */ './views/login/mobile/sn/sn.vue'),
    },
    {
      path: '/sn-register(.html)?',
      name: 'snRegister',
      component: () => import(/* webpackChunkName: "phoneRegister" */ './views/login/mobile/sn/register.vue'),
    },
    {
      path: '/login-success(.html)?',
      name: 'loginSuccess',
      component: () => import(/* webpackChunkName: "loginSuccess" */ './views/login/mobile/loginSuccess.vue'),
    },
    {
      path: '/logout(.html)?',
      name: 'logout',
      component: () => import(/* webpackChunkName: "logout" */ './views/login/logout.vue'),
    },
    {
      path: '/closeThisWindow(.html)?',
      name: 'closeThisWindow',
      component: () => import(/* webpackChunkName: "logout" */ './views/login/closeThisWindow.vue'),
    },
    {
      path: '/forget(.html)?',
      name: 'forget',
      component: () => import('./views/login/mobile/forget/forget.vue'),
    },
    {
      path: '/pc/login(.html)?',
      name: 'pcLogin',
      component: () => import('./views/login/pc/pc.vue'),
    }, {
      path: '/pc/register(.html)?',
      name: 'pcRegister',
      component: () => import('./views/login/pc/pc.vue'),
    },
    {
      path: '/pc/trible-login-return',
      name: 'tribleLoginReturn',
      component: () => import('./views/login/pc/tribleLoginReturn.vue'),
    },
    {
      path: '/pc/tri-login-run',
      name: 'triLoginRun',
      component: () => import('./views/login/pc/triLoginRun.vue'),
    },
    {
      path: '/pc/suning-passport-return',
      name: 'suningPassportReturn',
      component: () => import('./views/login/pc/suningPassportReturn.vue'),
    },
    {
      path: '/cancel-payment',
      name: 'cancelPayment',
      component: () => import('./views/pay/mobile/cancelPayment.vue'),
    },
    {
      path: '/member-payment',
      name: 'memberPayment',
      component: () => import('./views/pay/mobile/memberPayment.vue'),
    },
    {
      path: '/pc/pay(.html)?',
      name: 'pcPay',
      component: () => import('./views/pay/pc/pay.vue'),
    },
    {
      path: '/h5/pay(.html)?',
      name: 'h5Pay',
      component: () => import('./views/pay/mobile/rectPay.vue'),
    },
    {
      path: '/h5/pay/to-app(.html)?',
      name: 'toApp',
      component: () => import('./views/pay/mobile/toApp.vue'),
    },
    {
      path: '/h5/pay/result(.html)?',
      name: 'payResult',
      component: () => import('./views/pay/mobile/result.vue'),
    },
    {
      path: '/h5/pay/exchange(.html)?',
      name: 'exchange',
      component: () => import('./views/pay/mobile/exchangeCoupons.vue'),
    },
    {
      path: '/h5/pay/deposit(.html)?',
      name: 'deposit',
      component: () => import('./views/pay/mobile/memberDeposit.vue'),
    },
    {
      path: '/h5/pay/renew(.html)?',
      name: 'renew',
      component: () => import('./views/pay/mobile/renew.vue'),
    },
    {
      path: '/pptv/vip/clause(.html)?',
      name: 'clause',
      component: () => import('./views/pay/mobile/clause.vue'),
    },
    {
      path: '/pptv/vip/protocol(.html)?',
      name: 'protocol',
      component: () => import('./views/pay/mobile/protocol.vue'),
    },
    {
      path: '/pptv/securitycenter/:step',
      name: 'securitycenter',
      component: () => import('./views/securitycenter/mobile/securitycenter.vue'),
    },
    {
      path: '/pc/pptv/securitycenter/:step',
      name: 'pcsecuritycenter',
      component: () => import('./views/securitycenter/pc/securitycenter.vue'),
    },
  ],
});
